export default __webpack_public_path__ + "static/media/chart-grouping.051ceda2.png";